/**
 * Bridge Stretch theme cart events → Rebuy Smart Cart
 *
 * Stretch (Maestrooo) adds to cart via AJAX and fires:
 *   - variant:add  (PDP + quick buy)  https://support.maestrooo.com/article/764-javascript-events-exposed-by-the-theme
 *   - cart:change  (all cart updates)
 *
 * Rebuy Smart Cart does not listen to those events by default, so we open it
 * explicitly: https://developers.rebuyengine.com/reference/smart-cart/
 */
(function () {
  var READY_POLL_MS = 100;
  var READY_TIMEOUT_MS = 10000;

  function whenSmartCartReady(callback) {
    var started = Date.now();

    function check() {
      if (window.Rebuy && Rebuy.SmartCart && Rebuy.SmartCart.status === 'ready') {
        callback(Rebuy.SmartCart);
        return;
      }

      if (Date.now() - started > READY_TIMEOUT_MS) return;
      setTimeout(check, READY_POLL_MS);
    }

    check();
  }

  function openSmartCart(cart) {
    whenSmartCartReady(function (smartCart) {
      if (cart && typeof smartCart.setCart === 'function') {
        smartCart.setCart(cart);
      }
      smartCart.show();
    });
  }

  // PDP + quick-buy add-to-cart (Stretch product-form)
  document.addEventListener('variant:add', function (event) {
    openSmartCart(event.detail && event.detail.cart);
  });

  // Header / any control that would open the theme cart drawer → Smart Cart instead
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[aria-controls="cart-drawer"], [data-open-rebuy-cart]');
      if (!trigger) return;

      // Allow modifier-clicks / middle-click to open /cart in a new tab
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      openSmartCart();
    },
    true
  );
})();
